/**
 * Telemetria de escuta do LeadTalk/LeadMusic (porta de `checkLeadTalk` [application.js:2285]
 * + gravação em `showMultimedia` [7613-7849]).
 *
 * Enquanto o áudio/vídeo toca, o AudioPlayer grava `leadTalk[id] = { title, source, time }`
 * no chrome.storage.LOCAL da extensão (via bridge). No boot, `flushLeadTalk()` lê esse mapa,
 * envia os itens com tempo > 0 para POST /app/leadtalk e zera o storage.
 */
import { getLocal, setLocal } from '../lib/extensionBridge';
import { api } from '../lib/apiClient';

export interface LeadTalkEntry {
  title?: string;
  source?: string;
  time?: number;
}

type LeadTalkMap = Record<string, LeadTalkEntry>;

/** Semeia a entrada ao abrir um episódio (time 0). */
export async function seedLeadTalk(id: string, title: string, source: string): Promise<void> {
  try {
    const local = await getLocal<{ leadTalk?: LeadTalkMap }>();
    const leadTalk = { ...(local.leadTalk ?? {}) };
    leadTalk[id] = { title, source, time: 0 };
    setLocal({ leadTalk });
  } catch {
    /* extensão ausente — telemetria opcional */
  }
}

/** Atualiza o tempo escutado (segundos) de um episódio. */
export async function updateLeadTalkTime(id: string, time: number): Promise<void> {
  try {
    const local = await getLocal<{ leadTalk?: LeadTalkMap }>();
    const leadTalk = { ...(local.leadTalk ?? {}) };
    if (leadTalk[id]) {
      leadTalk[id] = { ...leadTalk[id], time };
      setLocal({ leadTalk });
    }
  } catch {
    /* extensão ausente — telemetria opcional */
  }
}

/** No boot: envia os tempos acumulados e limpa o storage (checkLeadTalk). */
export async function flushLeadTalk(): Promise<void> {
  try {
    const local = await getLocal<{ leadTalk?: LeadTalkMap }>();
    const map = local.leadTalk;
    if (!map || Object.keys(map).length === 0) return;

    const leadTalk = Object.values(map)
      .filter((v) => v && typeof v.time === 'number' && v.time > 0)
      .map((v) => ({ title: v.title, source: v.source, time: v.time }));
    if (leadTalk.length === 0) return;

    const result = await api.post('app/leadtalk', { leadTalk }, { allowEmpty: true });
    if (result.ok) setLocal({ leadTalk: {} });
  } catch {
    /* extensão ausente ou offline — tenta de novo no próximo boot */
  }
}
